import { useCallback, useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import { Module } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import useModulesAnalytics from "../../useModulesAnalytics";
import useCellFilterAction from "../useCellFilterAction";
import { ModulesSuggestions } from "../../FiltersLayout/constants";

const ModulesTableSpaceCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const trackAnalytics = useModulesAnalytics();

  const spaceFilterAction = useCellFilterAction({
    filterName: ModulesSuggestions.Space,
    filterValue: module.spaceDetails.id,
    spaceCell: true,
  });

  const handlePress = useCallback(() => {
    trackAnalytics("Space link clicked");
  }, [trackAnalytics]);

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <TableCellSpace href={`/spaces/${module.spaceDetails.id}`} onPress={handlePress}>
        {module.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default ModulesTableSpaceCell;
